<template>
  <div class="popup-manageResa popup-aside-float" :class="{ 'popup-manageResa-dark': currentMod === 'EDIT' }">
    <div class="popup-manageResa-header">
      <div class="nav-toggle" @click="closePopup">
        <div id="nav-icon3" class="open">
          <span></span><span></span><span></span><span></span>
        </div>
      </div>
      <div class="popup-manageResa-title" :class="getHeaderClass">
        <div class="popup-manageResa-title-content">{{ getHeaderTitle }}</div>
      </div>
    </div>
    <div ref="popup-manageResa" class="popup-manageResa-container">
      <transition name="fade">
        <div class="popup-manageResa-content" v-if="currentMod === 'READ'">
          <div class="popup-manageResa-resaTitle">
            {{ getSelectedResa.dateResa.labelDay }} {{ getSelectedResa.dateResa.day }}
            {{ getSelectedResa.dateResa.labelMonth }} à {{ getSelectedResa.hour }}
          </div>
          <div class="popup-manageResa-resaTitle"
            v-if="getSelectedResa.tids !== undefined && getSelectedResa.tids.length > 0">
            Table<span v-if="getSelectedResa.tids.length > 1">s</span>
            <span> {{ getLinkedTablesToString }}</span>
          </div>
          <div class="popup-manageResa-line">
            <div v-if="getSelectedResa.discount" class="popup-manageResa-discount">
              <p>
                -{{ getSelectedResa.discount }}%
              </p>
            </div>
            <div class="popup-manageResa-nbCouvert-count">
              {{ getSelectedResa.nbCouvert }}
            </div>
            <div class="popup-manageResa-nbCouvert"></div>
            <div class="popup-manageResa-tag" :class="'popup-manageResa-tag-' + getSelectedResa.source.toLowerCase()">
            </div>
            <div :class="[
              'popup-manageResa-cash',
              'popup-manageResa-cash-' + resaPayementColorState,
            ]" v-if="this.getSelectedResa.type !== '' && getSelectedResa.amount > 0">
              {{ getTypeCash(getSelectedResa.type) }} :
              <span v-if="getSelectedResa.total">{{ getSelectedResa.total }}</span><span v-else>{{
                Math.round((getSelectedResa.amount * getSelectedResa.nbCouvert) * 100) / 100 }}</span>€
            </div>
          </div>
          <div class="popup-manageResa-label">
            <client-tag v-for="tag in getClientByid(clientResa.cid).tags.slice().sort()" :key="tag" :idTag="tag"
              :deletable="false" :cid="clientResa.cid"></client-tag>
          </div>
          <div class="popup-manageResa-denom" @click="editClientInfos(clientResa.cid)">
            {{
              clientResa.civ === "Mme." ? clientResa.civ.replace(".", "") : clientResa.civ
            }}
            {{ clientResa.name }} {{ clientResa.prenom }}
            <img class="popup-manageResa-denom-img" src="../../assets/svg/asset-more.svg" alt="" />
            <span class="popup-manageResa-societe" v-if="clientResa.societe && clientResa.societe !== ''">
              <br />
              {{ clientResa.societe }}
            </span>
          </div>
          <div class="popup-manageResa-contact">
            <span v-if="formatPhone(clientResa.tel, clientResa.telPreFix)">
              <a :href="'tel:' + formatPhone(clientResa.tel, clientResa.telPreFix)">{{
                formatPhone(clientResa.tel, clientResa.telPreFix)
              }}</a>
              <br /><br />
            </span>
            <a v-if="clientResa.email !== '-' || clientResa.email !== '' || clientResa.email !== ' '"
              :href="'mailto:' + clientResa.email">{{
                clientResa.email
              }}</a>
          </div>
          <div class="popup-manageResa-comment"
            v-if="getSelectedResa.allergen && getSelectedResa.allergenMessage !== ''">
            <div class="popup-manageResa-tag" :class="'popup-manageResa-tag-allergen'"></div>
            {{ getSelectedResa.allergenMessage }}
          </div>
          <div class="popup-manageResa-preFixServ"
            v-if="getSelectedResa.preFixServ && getSelectedResa.preFixServ !== ''">
            Interne : {{ getSelectedResa.preFixServ }}
          </div>
          <div class="popup-manageResa-comment" v-if="clientResa.comment && clientResa.comment !== ''">
            Note client : {{ clientResa.comment }}
          </div>
          <div class="popup-manageResa-comment"
            v-if="getSelectedResa.commentResa && getSelectedResa.commentResa !== ''">
            Note réservation : {{ getSelectedResa.commentResa }}
          </div>
          <div class="popup-manageResa-state" v-if="
            (getStateResa === 'CONFIRMED' ||
              getStateResa === 'NO_SHOW' ||
              getStateResa === 'NEED_TABLE' ||
              getStateResa === 'SHOW') &&
            clientResa.cid !== 'passage'
          ">
            <el-radio-group v-if="inCurrentService(true)" v-model="radioState" @change="changeStateConfirmedResa">
              <el-radio-button class="red" label="No show" value="NO_SHOW"></el-radio-button>
              <el-radio-button label="Neutre" value="CONFIRMED"></el-radio-button>
              <el-radio-button class="green" label="Show" value="SHOW"></el-radio-button>
            </el-radio-group>
          </div>
          <div
            v-if="(getStateResa === 'SHOW' || getStateResa === 'DONE') && getAllInfos.restoReviewsLinks && getAllInfos.restoReviewsLinks.length > 0"
            class="popup-manageResa-btns popup-manageResa-reviews black-inputs">
            <el-button v-if="!askReview && !getAllInfos.restoReviews" class="green" type="primary"
              @click="askForReviews()">Demande d'avis</el-button>
            <div v-else-if="askReview" class="popup-manageResa-reviews-txt">
              Demande d'avis envoyé
            </div>
          </div>
          <div class="popup-manageResa-btns black-inputs">
            <el-button v-if="getStateResa === 'TO_CONFIRM'" type="primary" @click="confirmResa">Valider la
              réservation</el-button>
            <el-button v-if="
              getStateResa !== 'CANCELLED' &&
              getStateResa !== 'NO_SHOW' &&
              getStateResa !== 'DONE' &&
              clientResa.cid !== 'passage'
            " class="dark" type="primary" @click="editResa">Modifier les informations</el-button>
            <el-button v-if="
              getStateResa !== 'CANCELLED' &&
              getStateResa !== 'NO_SHOW' &&
              getStateResa !== 'SHOW' &&
              getStateResa !== 'DONE'
            " class="dark" type="primary" @click="reSendConfirm">Renvoyer les informations</el-button>
            <el-button v-if="
              getStateResa !== 'CANCELLED' &&
              getStateResa !== 'NO_SHOW' &&
              getStateResa !== 'SHOW' &&
              getStateResa !== 'DONE'
            " class="dark" type="primary" @click="cancelResa">Annuler la réservation</el-button>
            <el-button v-if="getStateResa === 'SHOW'" class="dark" type="primary" @click="setTableDONE()">Libérer les
              tables</el-button>
          </div>
          <div class="popup-manageResa-booking">
            Enregistrée le :<br> {{ getDateBooking }} depuis <span class="capitalize">{{ getSelectedResa.source
            }}</span><br>
            <span v-if="getStateResa !== 'CANCELLED' && getDateModify && getModifyBy">
              Mise à jour le :<br> {{ getDateModify }} par {{ getModifyBy }}
            </span>
            <span v-else-if="getDateModify && getModifyBy">
              Annulée le :<br> {{ getDateModify }} par {{ getModifyBy }}
            </span>
          </div>
        </div>
        <div class="popup-manageResa-content" v-if="currentMod === 'EDIT'">
          <el-row class="black-inputs">
            <el-col :span="20" :offset="2">
              <el-form ref="editForm" :rules="rulesFormPart1" :model="editForm" label-width="0px">
                <el-form-item class="civ">
                  <el-radio-group v-model="editForm.civ">
                    <el-radio-button label="M."></el-radio-button>
                    <el-radio-button label="Mme"></el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item prop="clientPreFix" class="cPrefix">
                  <el-input v-model="editForm.preFix" placeholder="Préfixe"></el-input>
                </el-form-item>
                <el-form-item prop="name">
                  <el-input v-model="editForm.name" placeholder="Nom*"></el-input>
                </el-form-item>
                <el-form-item prop="prenom">
                  <el-input v-model="editForm.prenom" placeholder="Prénom*"></el-input>
                </el-form-item>
                <el-form-item prop="email">
                  <el-input v-model="editForm.email" placeholder="e-mail*"></el-input>
                </el-form-item>
                <el-form-item prop="telPreFix" class="tel-prefix">
                  <el-input v-model="editForm.telPreFix" placeholder="+33"></el-input>
                </el-form-item>
                <el-form-item prop="tel" class="tel">
                  <el-input v-model="editForm.tel" placeholder="Téléphone*"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="editForm.societe" placeholder="Société"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input-number @focus="focusNumber" class="text-centered" style="width: 100%" size="medium" :min="1"
                    v-model="editForm.nbCouvert"></el-input-number>
                </el-form-item>
                <el-form-item>
                  <calendar-nav-picker />
                </el-form-item>
                <el-form-item>
                  <div class="popup-takeResa-dayClosed" v-if="getServicesHours === null">
                    Fermé
                  </div>
                  <el-select v-if="getServicesHours !== null" class="text-centered" v-model="editForm.hour"
                    @change="serviceChange" value-key="id" placeholder="Choisissez une heure">
                    <el-option-group v-for="ms in getServicesHoursData" :key="ms.label" :label="ms.label"
                      v-if="ms.tab.length > 0">
                      <el-option v-for="h in ms.tab" :key="h.id" :label="h.hour" :value="h">
                      </el-option>
                    </el-option-group>
                  </el-select>
                </el-form-item>
                <el-form-item prop="allergen">
                  <div>
                    <el-radio-group v-model="editForm.allergen" @change="$refs['editForm'].clearValidate()">
                      <el-radio style="white-space: normal; padding:5px 10px" :label="false">Aucune intolérance ou
                        allergie pour l’ensemble des convives</el-radio>
                      <el-radio style="white-space: normal; padding:5px 10px" :label="true">Intolérance / Allergie
                      </el-radio>
                    </el-radio-group>
                  </div>
                </el-form-item>
                <el-form-item v-if="editForm.allergen" prop="allergenMessage">
                  <el-input v-model="editForm.allergenMessage" :autosize="{ minRows: 3 }" type="textarea"
                    placeholder="Merci de renseigner les intolérances / allergies"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="editForm.commentResa" :autosize="{ minRows: 3 }" type="textarea"
                    placeholder="Commentaire concernant la réservation"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="editForm.preFixServ" placeholder="Interne"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="validModifResa()">Valider</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button class="dark" type="primary" @click="closeEditResa()">Annuler</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import * as resaState from '../../store/types/resa-state'
import { focusBlur } from '../../tools/eventTools'
import { sendResaAskReview, sendResaConfirmedMessage } from '../../tools/messageSender'
import {
  compareTime,
  dateToTimeStamp,
  formatTimeH,
  parseTime
} from '../../tools/timeTool'
import { checkPhone, validatePrefix } from '../../tools/validator'
import CalendarNavPicker from '../calendar/CalendarNavPicker.vue'
import ClientTag from '../clients/ClientTag.vue'

export default {
  name: 'PopupManageResa',
  components: { CalendarNavPicker, ClientTag },
  data() {
    return {
      radioState: 'Neutre',
      currentMod: 'READ',
      askReview: false,
      tabHours: {},
      editForm: {}
    }
  },
  created: function () {
    let stateLabel = 'Neutre'
    if (this.getSelectedResaState === 'SHOW') stateLabel = 'Show'
    else if (this.getSelectedResaState === 'NO_SHOW') stateLabel = 'No show'
    this.radioState = stateLabel
    // set rules for form 1
    this.rulesFormPart1 = {
      email: [
        {
          required: false,
          message: 'Merci de rentrer une adresse e-mail',
          trigger: 'blur'
        },
        {
          type: 'email',
          message: 'Merci de rentrer une adresse e-mail valide',
          trigger: 'blur'
        }
      ],
      name: [{ required: true, message: 'Merci de rentrer un nom', trigger: 'blur' }],
      prenom: [
        { required: true, message: 'Merci de rentrer un prénom', trigger: 'blur' }
      ],
      tel: [
        { validator: checkPhone, trigger: 'blur' },
        { required: false, message: 'Merci de rentrer un téléphone', trigger: 'blur' }
      ],
      telPreFix: [
        { validator: (rule, value, callback) => validatePrefix(rule, value, callback, this.editForm.tel), trigger: 'blur' },
        { required: true, message: 'Invalide', trigger: 'blur' }
      ]
    }
    this.askReview = this.getSelectedResa.askReview
  },
  destroyed: function () {
    this.setSelectedHour('')
  },
  computed: {
    ...mapGetters({
      getSelectedResa: 'newReservations/getSelectedResa',
      getSelectedResaState: 'newReservations/getSelectedResaState',
      getCurrentResaById: 'newReservations/getCurrentResaById',
      getClientByid: 'newClients/getClientByid',
      getLabelDay: 'calendar/getLabelDay',
      getLabelMonth: 'calendar/getLabelMonth',
      getSelectedDay: 'calendar/getSelectedDay',
      getCurrentTimestamp: 'calendar/getCurrentTimestamp',
      getSelectedTables: 'newRooms/getSelectedTables',
      getHoursDispoForSelectedTable: 'newRooms/getHoursDispoForSelectedTable',
      getLinkedResaIdsToTable: 'newRooms/getLinkedResaIdsToTable',
      selectedDayIsToday: 'calendar/selectedDayIsToday',
      getDateToTimestamp: 'calendar/getDateToTimestamp',
      getDaysIsClosed: 'newServices/getDaysIsClosed',
      inCurrentService: 'newServices/inCurrentService',
      getSelectedSubService: 'newServices/getSelectedSubService',
      getSelectedMainServiceData: 'newServices/getSelectedMainServiceData',
      getSelectedMainService: 'newServices/getSelectedMainService',
      getAllInfos: 'infos/getAllInfos',
      getUidPublic: 'newUsers/getUidPublic'
    }),
    getServicesHoursData: function () {
      return this.tabHours
    },
    getServicesHours: function (e) {
      if (
        this.getSelectedDay !== '' &&
        !this.getDaysIsClosed(this.getSelectedDay.weekday, false, new Date(this.getSelectedDay.date).getTime())
      ) {
        let did = this.getSelectedDay.weekday
        if (did === 0) did = 7
        return this.findFirstOpenServiceHours({
          day: this.getSelectedDay,
          keepCurrent: false,
          passed: true,
          checkLock: false
        }).then((tabHS) => {
          // get first disponnible hour
          // check if diff day of resa selected
          if (
            this.getSelectedDay.day === this.getSelectedResa.dateResa.day &&
            this.getSelectedDay.month === this.getSelectedResa.dateResa.month &&
            this.getSelectedDay.year === this.getSelectedResa.dateResa.year
          ) {
            // if current resa have tids !== [] reset table selected
            if (
              this.getSelectedResa.tids.length > 0 &&
              this.getSelectedTables.length === 0
            ) {
              this.setSelectedTables(this.getSelectedResa.tids)
            }
            // jour en cour
            let index = tabHS[this.getSelectedResa.subs].tab.findIndex((element) => {
              return element.hour === this.getSelectedResa.hour
            })
            this.editForm.hour = tabHS[this.getSelectedResa.subs].tab[index]
            this.setSelectedService({
              ms: this.getSelectedResa.ms,
              subs: this.getSelectedResa.subs
            })
            if (this.editForm.hour) {
              this.setSelectedHour(this.editForm.hour.hour)
            }
          } else {
            // different day
            this.editForm.hour = tabHS[Object.keys(tabHS)[0]].tab[0]
            this.setSelectedService({
              ms: tabHS[Object.keys(tabHS)[0]].tab[0].ms,
              subs: tabHS[Object.keys(tabHS)[0]].tab[0].subs
            })
            this.unSelectedTables(false)
          }
          this.tabHours = tabHS
          return tabHS
        })
      } else {
        return null
      }
    },
    getStateResa: function () {
      return this.getSelectedResaState
    },
    clientResa: function () {
      return this.getClientByid(this.getSelectedResa.cid)
    },
    getDateBooking: function () {
      let tmp = new Date(this.getSelectedResa.dateBooking)
      let time = new Date(this.getSelectedResa.createdAt)
      let idD = tmp.getDay()
      if (idD === 0) idD = 7
      return (
        `${this.getLabelDay(idD - 1)} ${tmp.getDate()} ${this.getLabelMonth(tmp.getMonth())} à ${this.leadingZero(time.getHours())}h${this.leadingZero(time.getMinutes())}`
      )
    },
    getDateModify: function () {
      let tmp = new Date(this.getSelectedResa.updatedAt)
      let time = new Date(this.getSelectedResa.createdAt)
      if (tmp.getTime() === time.getTime()) return false
      let idD = tmp.getDay()
      if (idD === 0) idD = 7
      return (
        `${this.getLabelDay(idD - 1)} ${tmp.getDate()} ${this.getLabelMonth(tmp.getMonth())} à ${this.leadingZero(tmp.getHours())}h${this.leadingZero(tmp.getMinutes())}`
      )
    },
    getModifyBy: function () {
      switch (this.getSelectedResa.modifyBy) {
        case 'CLIENT':
          return 'le client'
        case 'CLIENT_GOOGLE':
          return 'le client via Google'
        case 'RESTAURANT':
          return 'le restaurateur'
        case 'PERMANENCE' || 'PERMANANCE':
          return 'la permanence'
        case undefined || null:
          return null
      }
    },
    getHeaderTitle: function () {
      if (this.getSelectedResa !== null) {
        switch (this.getStateResa) {
          case resaState.TO_CONFIRM:
            return 'Nouvelle réservation'
          case resaState.CONFIRMED:
            return ' '
          case resaState.SHOW:
            return 'Réservation validée'
          case resaState.CANCELLED:
            return 'Réservation annulée'
          case resaState.NEED_TABLE:
            return 'Table non définie'
        }
      }
      return ''
    },
    getHeaderClass: function () {
      if (this.getSelectedResa !== null) {
        switch (this.getStateResa) {
          case resaState.TO_CONFIRM:
            return 'to-confirm'
          case resaState.CONFIRMED:
            return 'comming'
          case resaState.SHOW:
            return 'show'
          case resaState.NO_SHOW:
            return 'no-show'
          case resaState.CANCELLED:
            return 'cancelled'
          case resaState.NEED_TABLE:
            return 'need-table'
          case resaState.DONE:
            return 'done'
        }
      }
      return ''
    },
    getLinkedTablesToString: function () {
      let tmp = this.getSelectedResa.tids
      tmp.sort(function (a, b) {
        return a - b
      })
      let str = ''
      for (let i = 0; i < tmp.length; i++) {
        str += tmp[i].toString()
        if (i !== tmp.length - 1) str += ', '
      }
      return str
    },
    getLinkModify: function () {
      let host = `http://${window.location.hostname}`
      let ts = dateToTimeStamp(
        this.getSelectedResa.dateResa.day,
        this.getSelectedResa.dateResa.month - 1,
        this.getSelectedResa.dateResa.year
      )
      return (
        `${host}/change/${this.getUidPublic.toString()}/${ts.toString()}/${this.getSelectedResa.id.toString()}`
      )
    },
    resaPayementColorState: function () {
      if (this.getSelectedResa.payementDone) return 'green'
      else if (this.getSelectedResa.payementDone === false) return 'red'
      else return 'white'
    }
  },
  methods: {
    ...mapMutations({
      setSelectedResa: 'newReservations/setSelectedResa',
      setResaCanceling: 'newReservations/setResaCanceling',
      setDialogCancelResa: 'displayer/setDialogCancelResa',
      setDialogPayement: 'displayer/setDialogPayement',
      setModLinkTable: 'newRooms/setModLinkTable',
      setSelectedTables: 'newRooms/setSelectedTables',
      setSelectedHour: 'newReservations/setSelectedHour',
      setSelectedService: 'newServices/setSelectedService',
      setCidEditing: 'newClients/setCidEditing',
      setDialogEditClient: 'displayer/setDialogEditClient'
    }),
    ...mapActions({
      showHidePopupManageServices: 'displayer/showHidePopupManageServices',
      findFirstOpenServiceHours: 'newServices/findFirstOpenServiceHours',
      unLinkTables: 'newReservations/unLinkTables',
      updateStateResa: 'newReservations/updateStateResa',
      updateTablesLinked: 'newReservations/updateTablesLinked',
      moveResaTo: 'newReservations/moveResaTo',
      acceptResa: 'newReservations/acceptResa',
      unSelectedTables: 'newRooms/unSelectedTables',
      updateClientCount: 'newClients/updateClientCount',
      updateClientByCid: 'newClients/updateClientByCid'
    }),
    getTypeCash: function (type) {
      if (type === 'caution') return 'C'
      else return 'P'
    },
    leadingZero(value) {
      return (`0${value}`).slice(-2)
    },
    formatPhone: function (phone, phonePreFix) {
      if (phone.length < 3) return null
      if (phonePreFix !== '' && phone[0] !== '+') {
        let p = phone
        if (phone[0] === '0') p = phone.substring(1)
        return phonePreFix + p
      } else if (phone[0] !== '0' && phone[0] !== '+') {
        return `0${phone}`
      }
      return phone
    },
    editClientInfos: function (cid) {
      this.setCidEditing(cid)
      this.setDialogEditClient(true)
    },
    serviceChange: function (e) {
      if (this.getSelectedSubService !== e.ms) {
        this.unSelectedTables(false)
        this.setSelectedService({ ms: e.ms, subs: e.subs })
      }
      if (this.getSelectedTables.length > 0) {
        let hours = this.getHoursDispoForSelectedTable(true)
        let found = hours.find((checkedHour) => {
          return checkedHour === e.hour
        })
        if (found === undefined) this.unSelectedTables(false)
      }
      this.setSelectedHour(e.hour)
    },
    askForReviews: function () {
      let updateR = Object.assign({}, this.getSelectedResa)

      updateR.modifyBy = 'RESTAURANT'
      if (this.$router.currentRoute.name === 'PRedirect') updateR.modifyBy = 'PERMANENCE'

      updateR.askReview = true
      this.askReview = true
      let hourFormatted = formatTimeH(parseTime(this.getSelectedResa.hour))
      // send mail
      sendResaAskReview({
        restoid: this.getAllInfos.restoid,
        clientName: `${this.clientResa.name} ${this.clientResa.prenom}`,
        clientEmail: this.clientResa.email,
        restoName: this.getAllInfos.restoName,
        restoEmail: this.getAllInfos.restoMail,
        dateResa: `${this.getSelectedResa.dateResa.labelDay} ${this.getSelectedResa.dateResa.day.toString()} ${this.getSelectedResa.dateResa.labelMonth} ${this.getSelectedResa.dateResa.year.toString()}`,
        hourResa: hourFormatted,
        message: this.getAllInfos.resaAcceptedMessage,
        nbCouverts: this.getSelectedResa.nbCouvert,
        adresse: this.getAllInfos.restoAdresse,
        tel: this.getAllInfos.restoTel,
        type: this.getSelectedResa.type
      }).then(() => {
        // update state done
        this.updateStateResa({
          data: updateR,
          state: updateR.state,
          ts: this.getDateToTimestamp(updateR.dateResa),
          service: this.getSelectedSubService
        })
      }).catch(err => {
        console.error('sendResaAskReview', err)
      })
    },
    validModifResa: function () {
      this.$refs['editForm'].validate((valid) => {
        let formIsValid = valid
        if (formIsValid) {
          // make modification for client
          let updateC = Object.assign({}, this.clientResa)
          if (
            updateC.civ !== this.editForm.civ ||
            updateC.clientPreFix !== this.editForm.clientPreFix ||
            updateC.name !== this.editForm.name ||
            updateC.prenom !== this.editForm.prenom ||
            updateC.email !== this.editForm.email ||
            updateC.telPreFix !== this.editForm.telPreFix ||
            updateC.tel !== this.editForm.tel ||
            updateC.societe !== this.editForm.societe
          ) {
            updateC.civ = this.editForm.civ
            updateC.clientPreFix = this.editForm.clientPreFix
            updateC.name = this.editForm.name
            updateC.prenom = this.editForm.prenom
            updateC.email = this.editForm.email
            updateC.telPreFix = this.editForm.telPreFix
            updateC.tel = this.editForm.tel
            updateC.societe = this.editForm.societe
            updateC.nameLc = this.editForm.name.toLowerCase()
            updateC.prenomLc = this.editForm.prenom.toLowerCase()
            this.updateClientByCid(updateC)
          }
          // make modification for resa
          let updateR = Object.assign({}, this.getSelectedResa)
          if (
            updateR.nbCouvert !== this.editForm.nbCouvert ||
            updateR.preFix !== this.editForm.preFix ||
            updateR.preFixServ !== this.editForm.preFixServ ||
            updateR.dateResa.day !== this.getSelectedDay.day ||
            updateR.dateResa.month !== this.getSelectedDay.month ||
            updateR.dateResa.year !== this.getSelectedDay.year ||
            updateR.commentResa !== this.editForm.commentResa ||
            updateR.hour !== this.editForm.hour ||
            updateR.allergen !== this.editForm.allergen
          ) {
            updateR.nbCouvert = this.editForm.nbCouvert
            updateR.preFix = this.editForm.preFix
            updateR.preFixServ = this.editForm.preFixServ
            updateR.dateResa = this.getSelectedDay
            updateR.allergen = this.editForm.allergen
            updateR.allergenMessage = this.editForm.allergenMessage
            updateR.commentResa = this.editForm.commentResa
            updateR.subs = this.getSelectedSubService
            updateR.ms = this.getSelectedMainService
            if (this.editForm.hour.hour !== undefined) updateR.hour = this.editForm.hour.hour
            else updateR.hour = this.editForm.hour
            // table attribution
            let removeTable = false
            // check table dispo if date change
            if (
              updateR.tids.length > 0 &&
              (updateR.dateResa.day !== this.getSelectedResa.dateResa.day ||
                updateR.dateResa.month !== this.getSelectedResa.dateResa.month ||
                updateR.dateResa.year !== this.getSelectedResa.dateResa.year)
            ) {
              let resas = this.getLinkedResaIdsToTable(updateR.room, updateR.tids, false)
              if (resas.length !== 0) {
                removeTable = true
              }
            }
            // check table dispo for current day
            if (this.getSelectedTables.length > 0) {
              removeTable = false
              let hours = this.getHoursDispoForSelectedTable(true)
              if (hours.length === 0) {
                removeTable = true
              } else {
                let found = hours.find((checkedHour) => {
                  return checkedHour === updateR.hour
                })
                if (found === undefined) {
                  removeTable = true
                }
              }
            }
            // remove table attribution
            if (removeTable) {
              updateR.room = ''
              updateR.tids.length = 0
              this.unSelectedTables(false)
            }

            // update resas or move it to another timestamp
            if (
              updateR.dateResa.day !== this.getSelectedResa.dateResa.day ||
              updateR.dateResa.month !== this.getSelectedResa.dateResa.month ||
              updateR.dateResa.year !== this.getSelectedResa.dateResa.year
            ) {
              this.moveResaTo({
                data: updateR,
                prevTs: this.getDateToTimestamp(this.getSelectedResa.dateResa),
                prevService: this.getSelectedResa.subs,
                newTs: this.getDateToTimestamp(updateR.dateResa),
                newService: this.getSelectedSubService
              })
            } else {
              updateR.modifyBy = 'RESTAURANT'
              if (this.$router.currentRoute.name === 'PRedirect') updateR.modifyBy = 'PERMANENCE'

              this.updateStateResa({
                data: updateR,
                state: updateR.state,
                ts: this.getDateToTimestamp(updateR.dateResa),
                service: this.getSelectedSubService
              })
            }
          }
          this.setSelectedHour('')
          this.closePopup()
        } else {
          this.$refs['popup-manageResa'].scrollTop = 0
        }
      })
    },
    changeStateConfirmedResa: function (e) {
      let tmpState = ''
      let updateR = Object.assign({}, this.getSelectedResa)
      updateR.modifyBy = 'RESTAURANT'
      if (this.$router.currentRoute.name === 'PRedirect') updateR.modifyBy = 'PERMANENCE'

      switch (e) {
        case 'Show':
          if (this.getSelectedResaState === 'NO_SHOW') {
            tmpState = resaState.CONFIRMED
            // NO_SHOW -> SHOW = CONFIRMED / countNoShow ++
            this.updateClientCount({
              cid: this.getSelectedResa.cid,
              type: 'countNoShow',
              sub: true
            })
          } else {
            tmpState = resaState.SHOW
            // CONFIRMED -> SHOW / countShow ++
            this.updateClientCount({
              cid: this.getSelectedResa.cid,
              type: 'countShow',
              sub: false
            })
          }
          // check if PREVIOUS resa on same table if find something set it to DONE
          let allResaLinked = []
          this.getSelectedResa.tids.forEach((tid) => {
            this.getLinkedResaIdsToTable(this.getSelectedResa.room, tid).forEach(
              (rId) => {
                allResaLinked.push(rId)
              }
            )
          })
          if (allResaLinked.length > 0) {
            allResaLinked.forEach((rId) => {
              if (rId !== this.getSelectedResa.id) {
                let resa = this.getCurrentResaById(rId)
                if (compareTime(resa.hour, this.getSelectedResa.hour) < 0) {
                  // if exist if state SHOW -> DONE free table
                  if (resa.state === resaState.SHOW) {
                    this.updateTablesLinked({
                      state: resaState.DONE,
                      data: resa,
                      tids: resa.tids,
                      room: resa.room
                    })
                    // if exist if state CONFIRMED -> NO_SHOW
                  } else if (resa.state === resaState.CONFIRMED) {
                    this.unLinkTables({ stateResa: resaState.NO_SHOW, resa: resa })
                  }
                }
              }
            })
          }

          this.updateStateResa({
            data: updateR,
            state: tmpState,
            ts: this.getCurrentTimestamp,
            service: this.getSelectedSubService
          })
          if (tmpState === resaState.CONFIRMED) this.setModLinkTable(true)
          break
        case 'Neutre':
          if (this.getSelectedResaState === 'NO_SHOW') {
            // NO SHOW -> CONFIRMED / countNoShow --
            this.updateClientCount({
              cid: this.getSelectedResa.cid,
              type: 'countNoShow',
              sub: true
            })
          } else if (this.getSelectedResaState === 'SHOW') {
            // SHOW -> CONFIRMED / countShow --
            this.updateClientCount({
              cid: this.getSelectedResa.cid,
              type: 'countShow',
              sub: true
            })
          }
          tmpState = resaState.CONFIRMED
          this.setModLinkTable(true)

          this.updateStateResa({
            data: updateR,
            state: tmpState,
            ts: this.getCurrentTimestamp,
            service: this.getSelectedSubService
          })
          break
        case 'No show':
          if (this.getSelectedResaState === 'SHOW') {
            // SHOW -> NO SHOW / countShow --
            this.updateClientCount({
              cid: this.getSelectedResa.cid,
              type: 'countShow',
              sub: true
            })
          }
          if (this.getSelectedResa.type === 'caution') this.setDialogPayement(true)
          // CONFIRMED || SHOW -> NO SHOW / countNoShow ++
          this.updateClientCount({
            cid: this.getSelectedResa.cid,
            type: 'countNoShow',
            sub: false
          })
          this.updateTablesLinked({
            state: resaState.NO_SHOW,
            data: this.getSelectedResa,
            tids: this.getSelectedResa.tids,
            room: this.getSelectedResa.room
          })
          tmpState = resaState.NO_SHOW
          break
      }
      if (tmpState === resaState.NO_SHOW && this.getSelectedResa.type !== 'caution') {
        this.unSelectedTables()
      }
    },
    closePopup: function () {
      this.showHidePopupManageServices()
      this.setSelectedResa(null)
      if (this.getSelectedTables.length > 0) this.unSelectedTables()
      this.setModLinkTable(false)
    },
    confirmResa: function () {
      // if prepaiement open popup
      if (
        this.getSelectedResa.type === 'prepaiement' &&
        !this.getSelectedResa.payementDone
      ) {
        this.setDialogPayement(true)
      } else {
        this.acceptResa({
          resa: this.getSelectedResa,
          state: resaState.NEED_TABLE
        })
      }
    },
    editResa: function () {
      this.currentMod = 'EDIT'
      let civFormated =
        this.clientResa.civ === 'Mme.'
          ? this.clientResa.civ.replace('.', '')
          : this.clientResa.civ
      this.editForm = {
        civ: civFormated,
        clientPreFix: this.clientResa.clientPreFix,
        preFix: this.getSelectedResa.preFix,
        preFixServ: this.getSelectedResa.preFixServ,
        name: this.clientResa.name,
        prenom: this.clientResa.prenom,
        email: this.clientResa.email,
        telPreFix: this.clientResa.telPreFix,
        tel: this.clientResa.tel,
        societe: this.clientResa.societe,
        dateResa: this.getSelectedResa.dateResa,
        nbCouvert: this.getSelectedResa.nbCouvert,
        hour: this.getSelectedResa.hour,
        commentResa: this.getSelectedResa.commentResa,
        allergen: this.getSelectedResa.allergen,
        allergenMessage: this.getSelectedResa.allergenMessage
      }
    },
    closeEditResa: function () {
      this.currentMod = 'READ'
      this.setSelectedHour('')
    },
    reSendConfirm: function () {
      let hourFormatted = formatTimeH(parseTime(this.getSelectedResa.hour))
      // for client mail
      sendResaConfirmedMessage({
        clientName: `${this.clientResa.name} ${this.clientResa.prenom}`,
        clientEmail: this.clientResa.email,
        restoName: this.getAllInfos.restoName,
        restoEmail: this.getAllInfos.restoMail,
        dateResa: `${this.getSelectedResa.dateResa.labelDay} ${this.getSelectedResa.dateResa.day.toString()} ${this.getSelectedResa.dateResa.labelMonth} ${this.getSelectedResa.dateResa.year.toString()}`,
        hourResa: hourFormatted,
        message: this.getAllInfos.resaAcceptedMessage,
        nbCouverts: this.getSelectedResa.nbCouvert,
        adresse: this.getAllInfos.restoAdresse,
        tel: this.getAllInfos.restoTel,
        url: this.getLinkModify,
        type: this.getSelectedResa.type,
        total: this.getSelectedResa.total,
        restoid: this.getAllInfos.restoid,
        discount: null,
        sendSms: !!this.getAllInfos.clientSmsSended,
        clientTel: this.clientResa.tel,
        clientTelPreFix: this.clientResa.telPreFix
      })
    },
    setTableDONE: function () {
      this.updateTablesLinked({
        state: resaState.DONE,
        data: this.getSelectedResa,
        tids: this.getSelectedResa.tids,
        room: this.getSelectedResa.room
      })
      this.closePopup()
    },
    cancelResa: function () {
      this.setResaCanceling(this.getSelectedResa)
      this.setDialogCancelResa(true)
    },
    focusNumber: function (e) {
      focusBlur()
    }
  }
}
</script>

<style lang='scss'>
@use '../../styles/_vars';

.tel {
  width: 75%;
  margin-left: 1%;
  display: inline-block;

  &-prefix {
    width: 22%;
    display: inline-block;

    input {
      text-align: right;
    }
  }
}

.civ {
  width: 70%;
  display: inline-block;
}

.cPrefix {
  width: 26%;
  margin-left: 2%;
  display: inline-block;
}

.popup-manageResa-cash-red {
  color: var(--color_red);
}

.popup-manageResa-denom {
  cursor: pointer;
}

.popup-manageResa-societe {
  font-size: 12px;
}

.popup-manageResa-cash-green {
  color: var(--color_green);
}

.popup-manageResa-discount {
  display: inline-block;
  margin-right: 15px;
  background-color: var(--color_red);
  border-radius: 4px;
  padding: 0 4px;
  height: 25px;

  p {
    color: white;
    line-height: 25px;
    margin: 0;
  }
}
</style>
